<template>
  <div class="content">
    <div class="auth-tip-box" v-show="$store.getters.appKey.length === 0">
      <img src="~@/assets/img/kfc/home_icon_arrow_notice.png" alt="">
      <span class="tip-span">您还未授权公众号，请先</span>
      <span class="to-auth" @click="$store.commit('open/SET_addKfcDialog', true)">授权公众号</span>
      <img src="~@/assets/img/kfc/home_icon_arrow_right.png" alt="">
    </div>
    <Title :title="'应用开通'"></Title>
    <div class="allApp">
      <ul>
        <div class="layout">
          <li>
            <div class="title">
              <h5>肯德基在线点餐</h5>
              <p>自助点餐，随时随地5折点餐不排队</p>
            </div>
            <div class="logo">
              <img src="@/assets/img/open/logo_kfc_1.png" alt="">
            </div>
            <div class="btn" @click="openKfcBtn('kfc')">{{ openKfc ? '已添加应用' : '免费添加应用' }}</div>
          </li>
        </div>
        <!--        <div class="layout">-->
        <!--          <li>-->
        <!--            <div class="title">-->
        <!--              <h5>电费充值</h5>-->
        <!--              <p>电费特惠充值</p>-->
        <!--            </div>-->
        <!--            <div class="logo">-->
        <!--              <img src="@/assets/img/open/logo_dfcz_5.png" alt="">-->
        <!--            </div>-->
        <!--            <div class="btn" v-if="openElectricity" @click="openKfcBtn('electricity')">{{ openElectricity ? '已添加应用' : '免费添加应用' }}</div>-->
        <!--            <div class="ban" v-else>开发中，敬请期待…</div>-->
        <!--          </li>-->
        <!--        </div>-->
        <div class="layout">
          <li>
            <div class="title">
              <h5>麦当劳在线点餐</h5>
              <p>自助点餐，随时随地5折点餐不排队</p>
            </div>
            <div class="logo">
              <img src="@/assets/img/open/logo_mcdonalds_2.png" alt="">
            </div>
            <!-- <div class="btn">免费添加应用</div> -->
            <div class="ban">开发中，敬请期待…</div>
          </li>
        </div>
      </ul>
    </div>
    <div class="myApp">
      <div class="title" id="myApp">我的应用</div>
      <div class="yes" v-if="openKfc || openElectricity">
        <div class="item" v-if="openKfc">
          <div class="left">
            <img src="@/assets/img/open/kfclogo.png" alt="">
            <div class="text">
              <div class="top">
                <span>您的肯德基专属推广链接为：</span>
                <span class="hyperlink" @click="textCopy('kfc')">{{ kfcUrl }}</span>
              </div>
              <p>将链接放于您的公众号菜单栏中，会员点击链接就可以进入点餐页面，订单结算后您将获得订单利润分佣。</p>
            </div>
          </div>
          <div class="right">
            <div class="btn margin" @click="textCopy('kfc')">复制邀请链接</div>
            <div class="btn" @click="syncTemplate(1)">同步消息模板</div>
          </div>
        </div>
        <div class="item" v-if="openElectricity">
          <div class="left">
            <img src="@/assets/img/open/logo_dfcz_5.png" alt="">
            <div class="text">
              <div class="top">
                <span>您的电费充值专属推广链接为：</span>
                <span class="hyperlink" @click="textCopy('electricity')">{{ electricityUrl }}</span>
              </div>
              <p>将链接放于您的公众号菜单栏中，会员点击链接就可以进入充值页面，订单结算后您将获得订单利润分佣。</p>
            </div>
          </div>
          <div class="right">
            <div class="btn margin" @click="textCopy('electricity')">复制邀请链接</div>
            <div class="btn" @click="syncTemplate(3)">同步消息模板</div>
          </div>
        </div>
      </div>
      <div class="no" v-else>
        <div class="box">
          <img src="@/assets/img/open/blank_wyy.png" alt="">
        </div>
        <div class="box">
          <p>您还未添加任何应用</p>
        </div>
      </div>
    </div>
    <SyncTemplate ref="template"></SyncTemplate>

    <el-dialog title="公众号授权" :visible.sync="addKfcDialog" width="80%" :before-close="handleClose">
      <div class="auth-wrap">
        <div class="auth-box">
          <el-row>
            <el-col :span="6" class="auth-logo-div">
              <img class="auth-logo" src="@/assets/img/kfc/wechat_shouquanshuoming.png" alt="">
            </el-col>
            <el-col :span="18">
              <div class="auth-title">授权说明</div>
              <div class="auth-tip">
                <div class="part-box">
                  <div class="part-circle"></div>
                  <div class="part-content"><span>授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</span></div>
                </div>
                <div class="part-box">
                  <div class="part-circle"></div>
                  <div class="part-content"><span>如果你是公众号的管理员，点击下方按钮，扫码授权即可。</span></div>
                </div>
                <div class="part-box">
                  <div class="part-circle"></div>
                  <div class="part-content">
                    <span>如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</span>
                  </div>
                </div>
                <div class="btn-box">
                  <iframe frameborder="0" class="auth-btn" :src="authLink"></iframe>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Title from './components/title.vue'
import SyncTemplate from './components/SyncTemplate.vue'
import { getUserUUID } from '@/utils/auth'
import { getAuthorizedLink, getAppLink, openKFC, openElectricity } from '@/api/open.js'

export default {
  name: '',
  components: { Title, SyncTemplate },
  props: {},
  data() {
    return {
      // dialogVisible: false,
      copyText: '',
      appAuthority: true,
      kfcUrl: '',
      electricityUrl: '',
      openKfc: false,
      openElectricity: false,
      authLink: process.env.VUE_APP_NEW_OPEN_URL + '/third/go/auth-pub?userUUID=' + getUserUUID() + '&buttonText=点击开始授权公众号' + '&goUrl=' + encodeURIComponent(encodeURIComponent(window.location.href))
      // authLink: process.env.VUE_APP_NEW_OPEN_URL + '/third/go/auth-pub?userUUID=' + getUserUUID() + '&buttonText=点击开始授权公众号' + '&goUrl=http%253A%252F%252Fmovie-test.taototo.cn%252F%2523%252Fpc%252Fopen%252Fapplication'
    }
  },
  computed: {
    showAppKey() {
      return this.$store.getters.showAppKey
    },
    addKfcDialog() {
      return this.$store.getters.addKfcDialog
    }
  },
  watch: {},
  created() {
    this.$store.commit('nav/SET_ACTIVE_slideActive', 5)
    if (this.$store.getters.appKey.length !== 0) {
      this.getInfo()
    }
    console.log('authLink', this.authLink)
  },
  mounted() { },
  activated() { },
  deactivated() { },
  destroyed() { },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.$store.commit('open/SET_addKfcDialog', false)
          // done()
        })
        .catch(() => {
          // this.$store.commit('open/SET_addKfcDialog', true)
        })
    },
    async textCopy(appName) {
      switch (appName) {
        case 'kfc':
          this.copyText = this.kfcUrl
          break
        case 'electricity':
          this.copyText = this.electricityUrl
          break
        default:
          break
      }
      const val = this.copyText
      if (navigator.clipboard && window.isSecureContext) {
        console.log('writeText')
        // navigator clipboard 向剪贴板写文本
        this.$Message.success('复制成功')
        return navigator.clipboard.writeText(val)
      } else {
        let tempDom = document.querySelector('#myApp')
        console.log('execCommand')
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = val
        // 使text area不在viewport，同时设置不可见
        tempDom.appendChild(textArea)
        textArea.focus()
        textArea.select()
        this.$Message.success('复制成功')
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? res() : rej()
          textArea.remove()
        })
      }
    },
    // 同步模板消息
    syncTemplate(appId) {
      this.$refs.template.init(appId)
    },
    // 获取授权地址
    // async getAuthorizedLink() {
    //   const res = await getAuthorizedLink()
    //   console.log('获取授权地址', res.data)
    // }
    getInfo() {
      getAppLink({
        appKey: this.$store.getters.showAppKey.appKey
      }).then(res => {
        console.log('appLink', res)
        this.openKfc = res.data.openKfc
        this.openElectricity = res.data.openElectricity
        this.kfcUrl = res.data.kfcUrl
        this.electricityUrl = res.data.electricityUrl
      })
    },
    openKfcBtn(appName) {
      if (this.$store.getters.appKey.length === 0 && this.$store.getters.userToken !== '') {
        this.$message.warning('请先添加公众号')
      }

      if (this.$store.getters.appKey.length > 0) {
        switch (appName) {
          case 'kfc':
            if (!this.openKfc) {
              openKFC({
                appKey: this.$store.getters.showAppKey.appKey
              }).then(res => {
                this.$message.success(res.message || '成功')
                this.openKfc = true
              })
            }
            break
          case 'electricity':
            if (!this.openElectricity) {
              openElectricity({
                appKey: this.$store.getters.showAppKey.appKey
              }).then(res => {
                this.$message.success(res.message || '成功')
                this.openElectricity = true
              })
            }
            break

          default:
            break
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
.content {
  .allApp {
    margin-top: 20px;

    ul {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      //容器两边 减去内容的padding
      margin: 0 -1.78%;

      .layout {
        box-sizing: border-box;
        width: 33.33%;
        padding: 0 1.78%;
        margin-bottom: 20px;

        li {
          list-style: none;
          height: 148px;
          padding: 15px;
          border-radius: 4px;
          border: 1px solid #ebedf0;
          position: relative;
          display: flex;
          justify-content: space-between;

          .title {
            h5 {
              font-size: 19px;
              font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
              font-weight: normal;
              color: #222222;
            }

            p {
              font-size: 13px;
              font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
              font-weight: normal;
              color: #999999;
            }
          }

          .logo {
            width: 72px;
            height: 72px;
            margin-left: 2px;

            // position: absolute;
            // top: 15px;
            // right: 15px;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .btn {
            width: 115px;
            height: 32px;
            background: #ff8622;
            border-radius: 2px;
            text-align: center;
            padding: 6px 16px;
            color: white;
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            cursor: pointer;
            position: absolute;
            bottom: 15px;
            left: 15px;
          }

          .ban {
            width: 155px;
            height: 32px;
            background: #f5f5f5;
            border-radius: 2px;
            text-align: center;
            padding: 6px 16px;
            color: #999999;
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            // cursor: pointer;
            position: absolute;
            bottom: 15px;
            left: 15px;
          }
        }
      }
    }
  }

  .myApp {
    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      margin: 18px auto;
    }

    .yes {
      width: 100%;

      .item {
        width: 100%;
        display: flex;
        margin-bottom: 30px;
        justify-content: space-between;
        // border: 1px solid red;

        .left {
          width: 100%;
          display: flex;

          img {
            margin-right: 10px;
            width: 72px;
            height: 72px;
          }

          .text {
            margin: auto 0;

            .top {
              // display: flex;
              margin-bottom: 16px;
              width: 100%;

              .hyperlink {
                font-size: 14px;
                font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                font-weight: normal;
                color: #3d9efc;
                word-break: break-all;
                cursor: pointer;
              }
            }
          }
        }

        .right {
          margin-left: 23px;

          .btn {
            width: 115px;
            height: 32px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #ff8622;
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #ff8622;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
          }

          .margin {
            margin-bottom: 8px;
          }
        }

        p {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #666666;
        }
      }
    }

    .no {
      margin-top: 30px;

      .box {
        width: 100%;
        // position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          margin-top: 10px;
          height: 240px;
          width: 240px;
          // position: absolute;
          // top: 50%;
          // left: 50%;
          // transform: translate(-50%, -50%);
        }

        p {
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #999999;
        }
      }
    }
  }
}

.auth-tip-box {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #666666;
  text-align: justify;
  line-height: 40px;
  background: #fffbe6;
  border-radius: 4px;
  height: 40px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  img {
    width: 20px;
  }

  .tip-span {
    padding: 0 5px;
  }

  .to-auth {
    font-family: Alibaba-PuHuiTi-M;
    font-size: 16px;
    color: #d63036;
    cursor: pointer;
    text-decoration: underline;
  }
}

.auth-wrap .auth-box {
  padding: 60px 30px;
}

.auth-wrap .auth-box .auth-logo-div {
  padding-right: 30px;
}

.auth-wrap .auth-box .auth-logo {
  width: 100%;
  padding-top: 30px;
}

.auth-wrap .auth-box .auth-title,
.auth-detail .auth-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 20px;
  color: #222222;
}

.auth-wrap .auth-box .auth-tip,
.auth-detail .auth-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #666666;
  margin-top: 12px;
}

.auth-wrap .auth-box .part-box,
.auth-detail .part-box {
  display: flex;
  flex-direction: row;
  padding: 8px 0;
}

.auth-wrap .auth-box .part-box,
.auth-detail .right-box .part-box {
  padding: 5px 0;
}

.auth-wrap .auth-box .part-circle,
.auth-detail .part-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #d63036;
  margin: 5px 8px 5px 0;
}

.auth-detail .part-circle {
  background: #999999;
}

.auth-wrap .auth-box .part-content,
.auth-detail .part-content {
  width: 90%;
}

.auth-wrap .auth-box .btn-box {
  padding: 30px 10px;
}

.auth-wrap .auth-box .btn-box .auth-btn {
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
  font-family: Alibaba-PuHuiTi-R;
  background: #d63036;
  border-radius: 2px;
  color: #ffffff;
  margin: 0 auto;
  cursor: pointer;
  width: 180px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
}

.auth-wrap .auth-box .btn-box .auth-btn a {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/application.vue